export default __webpack_public_path__ + "static/media/logoMic.aed7af09.png";